module.exports = __webpack_public_path__ + "static/media/atmos_randolf_pitch.a5228b40.jpg";